import type {
  DICOM_Series,
  QCVisitWithSeries,
} from '@dynamika-shared/types/visits';

import {
  AssignedLabelsByVisit,
  FlatSeries,
  FlatVisits,
} from './QCTaskSeries.types';

export const convertSeriesToFlat = (
  series: DICOM_Series[],
  visitDefinitionId: string
): FlatSeries => {
  const result: FlatSeries = {};

  series.forEach(s => {
    result[s.id] = {
      ...s,
      visitDefinitionId,
    };
  });

  return result;
};

export const convertVisitsToFlat = (
  visits: QCVisitWithSeries[]
): FlatVisits => {
  const result: FlatVisits = {};

  visits.forEach(v => {
    result[v.visitDefinitionId] = {
      ...v,
      flatSeries: convertSeriesToFlat(v.dicomSeries ?? [], v.visitDefinitionId),
    };
  });

  return result;
};

export const makeAssignedLabelsByVisit = (
  flatVisits: FlatVisits
): AssignedLabelsByVisit => {
  const assignedLabelsByVisit: AssignedLabelsByVisit = {};
  for (const visit of Object.values(flatVisits || {})) {
    const labels: AssignedLabelsByVisit[0] = {};
    visit?.dicomSeries?.forEach(series => {
      if (series.labelId) {
        labels[series.labelId] = series;
      }
    });

    assignedLabelsByVisit[visit.visitDefinitionId] = labels;
  }
  return assignedLabelsByVisit;
};

export function transformSeries(series: QCVisitWithSeries[]) {
  const flatVisits = convertVisitsToFlat(series);
  const flatSeries = series?.reduce((acc, visit) => {
    return {
      ...acc,
      ...convertSeriesToFlat(visit.dicomSeries ?? [], visit.studyInstanceUid),
    };
  }, {});

  const assignedLabelsByVisit = makeAssignedLabelsByVisit(flatVisits);

  return { flatVisits, flatSeries, assignedLabelsByVisit };
}
